/**
 * `orange-footer` — prototype `footer()`.
 *
 * "Prototip intern · nu este un site public" stays. It is the one line that tells
 * anyone who lands on a deployed build of this that it is not the eShop, and it is
 * cheap insurance against a screenshot circulating without context.
 *
 * The four legal links are the real footer's and lead nowhere, so they are spans —
 * see `masthead.component.ts`. Terms are a real dependency of this flow (S-09,
 * Q-23) but the documents do not exist yet, and a link to a 404 is worse than text.
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';

const LINKS: readonly string[] = [
  $localize`:@@footer.terms:Termeni și condiții`,
  $localize`:@@footer.privacy:Confidențialitate`,
  $localize`:@@footer.cookies:Cookie-uri`,
  $localize`:@@footer.contact:Contact business`,
];

@Component({
  selector: 'orange-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="footer ground-inverse">
      <div>
        <span class="label" i18n="@@footer.orgName">Orange România</span>
        <span class="caption" i18n="@@footer.disclaimer">Prototip intern · nu este un site public</span>
      </div>

      <nav class="footer-links caption" [attr.aria-label]="label">
        @for (link of links; track link) {
          <span>{{ link }}</span>
        }
      </nav>
    </footer>
  `,
  styles: [
    `
      .footer {
        background: var(--surface-inverse);
        color: var(--surface);
        padding: var(--space-4) var(--gutter);
        font-size: 12px;
        line-height: 16px;
        display: flex;
        gap: var(--space-4);
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .footer > div {
        display: flex;
        flex-direction: column;
      }

      .footer-links {
        display: flex;
        gap: var(--space-3);
        flex-wrap: wrap;
      }
    `,
  ],
})
export class FooterComponent {
  readonly links = LINKS;
  readonly label = $localize`:@@footer.label:Legal`;
}
